export const iconFontAwesomeArrowsArrowRight = (
	<i className="fa-solid fa-arrow-right"></i>
);
